export enum Action {
  Accept = 'Accept',
  Reject = 'Reject'
}
